import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../../select-base';

@Component({
  selector: 'app-bir-supplier-class-select',
  templateUrl: './bir-supplier-class-select.component.html',
  styles: [
    `
      [nz-icon] {
        cursor: pointer;
      }
      [nz-select] {
        width: 180px;
      }
    `
  ],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BirSupplierClassSelectComponent),
      multi: true
    }
  ]
})
export class BirSupplierClassSelectComponent extends SelectBaseComponent {
  @Input() type: 'both' | 'customer' | 'supplier' = 'both';

  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
    this.valueField = '';
  }

  getUrl(searchValue: string): string {
    let filter = '';

    /*
    based on this WI, we need to filter data by customer or supplier here:
    https://dev.azure.com/qne/AccountingOnline/_workitems/edit/25170

      Filter by BIR type: isAR = Customer, isAP = Supplier
      */

    if (this.type === 'customer') {
      filter =
        '(IsAR eq true and IsAP eq false) or (IsAR eq true and IsAP eq true)';
    } else if (this.type === 'supplier') {
      filter =
        '(IsAP eq true and IsAR eq false) or (IsAP eq true and IsAR eq true)';
    }

    if (searchValue) {
      const searchFields = [
        'Code',
        'CompanyName',
        'FirstName',
        'MiddleName',
        'LastName',
        'TINNumber',
        'TINBranchCode',
        'Address'
      ];
      // Escape only single quotes for OData string literal; do not use encodeURIComponent here
      const searchStr = searchValue.replaceAll("'", "''");
      const searchFilter = searchFields
        .map(x => `contains(${x}, '${searchStr}')`)
        .join(' or ');

      if (filter) {
        filter += ` and (${searchFilter})`;
      } else {
        filter = `(${searchFilter})`;
      }
    }

    let url = `api/BIRClassifications/Query?$top=20&$skip=0&$orderby=Code asc`;

    if (filter) {
      url += `&$filter=${encodeURIComponent(filter)}`;
      url += `&keyword=${encodeURIComponent(searchValue.trim())}`;
    }

    return url;
  }
}
